import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { BContainer,BButton,BRow,BCol } from "bootstrap-vue-next";
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import bannerJp from '@/assets/chatty-reminders-image-1000x545_JP.png';
import bannerEn from '@/assets/chatty-reminders-image-1000x545_EN.png';

export default {
  name: 'Init',
  components: {
    Loading,BContainer,BButton,BRow,BCol,LanguageSwitcher
  },

  // 共通関数
  //mixins: [netutils],

  // ローカルデータ変数
  data() {
    return {
      // メッセージ
      message: {
        is_alert: false,
        variant: "",
        message: "",
      },
      // ローディング
      loader: {
        is_loading: false,
        is_full_page: true,
      },
      // バインドデータ
      bind_data: {
      },
      // ローカルデータ
      local_data: {
      },
      // 状態データ
      state_data: {
      }
    }
  },

  // 既定計算
  computed: {
    bannerImage() {
      const locale = (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : 'ja';
      return locale === 'en' ? bannerEn : bannerJp;
    }
  },

  // インスタンス初期化後
  created: function(){
  },
  // インスタンス破棄後
  destroyed: function() {
  },
  // インスタンスマウント後
  mounted: async function(){
    
    // ローディング開始
    this.loader.is_loading = true;

    let href = window.location.href;
    console.log("Init:href="+href);

    // URLのパラメータが params 付きかどうか、チェックする
    let url = window.location.search;
    console.log("Init:url="+url);
    //await this.post_debugger("Init:mounted:url="+url);

    let params = new URLSearchParams(url);
    console.log("Init:params="+params);

    // ローディング終了
    this.loader.is_loading = false;
  },

  // ローカル関数
  methods: {
    home(){
      // 画面遷移
      this.$router.push({ path:'/Home' });
    },
    qa(){
      // 画面遷移
      this.$router.push({ path:'/QA' });
    },
    privacy_policy(){
      // 画面遷移
      this.$router.push({ path:'/PrivacyPolicy' });
    },
    terms_of_service(){
      // 画面遷移
      this.$router.push({ path:'/TermsOfService' });
    },
  }
}
